import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  simulated_date: null, // ISO datetime string when set, null when not simulating
  needsRefresh: false,
}

export const simulatedDateSlice = createSlice({
  name: 'simulatedDate',
  initialState,
  reducers: {
    setSimulatedDate: (state, action) => {
      state.simulated_date = action.payload.simulated_date
      state.needsRefresh = action.payload.needsRefresh ?? false
    },
    clearSimulatedDate: (state) => {
      state.simulated_date = null
      state.needsRefresh = false
    },
    setNeedsRefresh: (state, action) => {
      state.needsRefresh = action.payload
    },
  },
})

export const { setSimulatedDate, clearSimulatedDate, setNeedsRefresh } = simulatedDateSlice.actions
export const selectSimulatedDate = (state) => state.simulatedDate
export default simulatedDateSlice.reducer
